import React from 'react';
import * as FiIcons from 'react-icons/fi';

const SafeIcon = ({ icon, className, ...props }) => {
  if (!icon) return null;
  const IconComponent = icon;
  return <IconComponent className={className} {...props} />;
};

export default SafeIcon;